import { useEffect, useState } from "react";
import { Accordion, Row, Col, Dropdown } from "react-bootstrap";
import { createPortal } from "react-dom";
import { DonorService } from "../../Services/Donor.Service";
const TravelDistance = ({userData, setToastMessage, setToastVariant, setShowToast, setLoading}) => {
    const [selectedTravelDistance, setSelectedTravelDistance] = useState("");

    const [error, setError] = useState(null);
    
    const travelOptions = {
        5: "Less than 5 miles",
        10: "Less than 10 miles",
        15: "Less than 15 miles",
        20: "Less than 20 miles",
    };

    useEffect(() => {
        if (userData && userData.travel_dist) {
            setSelectedTravelDistance(userData.travel_dist.toString());
        }
    }, [userData]);

    const handleTravelDistanceChange = (value) => {
        setSelectedTravelDistance(value);
        setError(null);
    };
    const menuRoot = document.getElementById("root");


  const updateTravelDistance = async () => {
    setError(null);

    if (!selectedTravelDistance) {
      setError("Please select a travel distance before saving.");
      return;
    }
    setLoading(true);
    const payload = {
      user_id: userData.id,
      travel_distance: selectedTravelDistance,
    };

    try {
      const response = await DonorService.updateTravelDistance(payload);
      console.log(response.message);
      setToastMessage(response.message);
      setToastVariant("success");
      setShowToast(true);
      setLoading(false);

    } catch (err) {
      console.error("Error updating travel distance:", err);
      setLoading(false);
      setToastMessage(err.message);
      setToastVariant("error");
      setShowToast(true);
    }
  };

    return (
         <div>
            <div className="el-bg-table el-super-admin mt-3">
                <Accordion alwaysOpen defaultActiveKey={["3"]} flush>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header className="cursor-pointer">
                             <div>
                                <div><b>Travel Distance</b></div>
                                <div><p>Select the travel distance.</p></div>
                            </div>
                        </Accordion.Header>
                         <Accordion.Body>
                            <container className="el-property-details-card-content">
                                <Row>
                                    <Col md={12} className="mx-fit-content">
                                        <div className="row mt-2">
                                              <Dropdown className="dropdown-travel-dist" onSelect={handleTravelDistanceChange}>
                                                <Dropdown.Toggle
                                                    variant="secondary"
                                                    className="navbar-drop-buttons"
                                                    id="dropdown-basic"
                                                >
                                                    {selectedTravelDistance
                                                        ? travelOptions[selectedTravelDistance]
                                                        : "Select Travel Distance"}
                                                </Dropdown.Toggle>
                                                  {createPortal(
                                                <Dropdown.Menu
                                                    className="el-admin "
                                                    // style={{ zIndex: 9999, position: "relative" }}
                                                >
                                                    {Object.entries(travelOptions).map(([key, label]) => (
                                                        <Dropdown.Item key={key} eventKey={key}>
                                                            {label}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>,

                                                menuRoot  )}
                                            </Dropdown>
                                            {error && <div className="text-danger">{error}</div>}

                                        </div>
                                    </Col>
                                </Row>
                            </container>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <div className="d-flex align-items-center mt-3">
                    <button onClick={updateTravelDistance} className="el-main-button me-3">
                    <span>Save Changes</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
export default TravelDistance;